import axios from "axios";
import store from '../../store';
import AppConsts from "../../../appconst";
import * as actions from "./TicketsTypes";
import { UserLogout } from '../../Login/LoginActions';

export const getPrjListForTkt = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetPrjListForTkt",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETPRJLISTFORTKT, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getSubPrjList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetSubPrjList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSUBPRJLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getIssueTypeList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetIssueTypeList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETISSUETYPELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveTicketDetail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveTicket",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getTktColumnList = async (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetTktColumnList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTKTCOLUMNLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getUserTktColumnList = async (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetUserTktColumnList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERTKTCOLUMNLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const saveTktUserForm = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveTktUserForm",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const saveTktUserDefault = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveTktUserDefault",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getTicketDetail = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetTicketForEdit",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SETTICKETDETAIL, payload: { list: response.data } });
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
            console.log({ content: err.message });
        });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const saveLogWorkDetail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveLogWork",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const deleteLogWorkDetail = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/SupportDesk/DeleteLogWork",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const saveComment = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveComment",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const deleteComment = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/SupportDesk/DeleteComment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteAttachment = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/SupportDesk/DeleteAttachment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getSearchTicketList = async (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetSearchTicketList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTktCountList = async (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetTktCountList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETCOUNTLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getUserDefault = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetUserDefault",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERDEFAULTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getAgentList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetAgentList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETAGENTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveAgent = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveAgent",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getReplyMailList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetReplyMailList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETREPLYMAILLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const sendReplyEmail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/sendReplyEmail",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const exportTicket = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/ExportTicket",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getClosedEmailContent = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetClosedEmailContent",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETCLOSEDEMAILCONTENT, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getUserReviewEmailContent = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetUserReviewEmailContent",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERREVIEWEMAILCONTENT, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const sendStatusTktEmail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/sendClosedTktEmail",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const sendPendingMail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SendPendingMail",
                params: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const discardPendingMail = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/DiscardPendingMail",
                params: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getAgedTickets = (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetAgedTickets",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err.response.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getAgedTicketReasonList = (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetAgedTicketReasonList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDELAYEDREASONLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err.response.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getAgedTicketReviewList = (data) => {
    try {
        var result = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetAgedTicketsReview",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETAGEDTICKETREVIEWLIST, payload: { list: response.data } });
                return response.data;
            })
            .catch(err => {
                if (err.response.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout(); }
                        });
                    }
                }
                console.log({ content: err.message });
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveDelayedTickets = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveDelayedTickets",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const saveAgedTicketsReview = async (data) => {
    try {
        var result = await
            axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/SupportDesk/SaveAgedTicketsReview",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err?.response?.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout(); }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};


export const saveResolution = async (data) => {
    try {
        const result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/SupportDesk/SaveResolution",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            return response.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };

            return { result: false, message: err.message };
        });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    };
};

export const getResolutionByTicketId = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetResolutionByTicketId",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_RESOLUTION_BY_TICKET_ID, payload: { list: response?.data } });
            return response?.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
        });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};

export const getAllRootCauses = async (data) => {
    try {
        const apiResponse = axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/SupportDesk/GetAllRootCauses",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        }).then(response => {
            store.dispatch({ type: actions.SET_ALL_ROOT_CAUSES, payload: { list: response?.data } });
            return response?.data;
        }).catch(err => {
            if (err?.response?.status == 401) {
                if (!logout) {
                    logout = true;
                    Modal.confirm({
                        content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                        onOk: () => { UserLogout(); }
                    });
                };
            };
        });

        return apiResponse;
    }
    catch (err) {
        console.log({ content: err.message });
    };
};